import React from 'react';
import CampaignSSOLoginContainer from 'containers/CampaignSSOLogin';

function CampaignSSOLogin(props) {
    return (
        <CampaignSSOLoginContainer {...props} />
    );
}

export default CampaignSSOLogin;